import * as z from "zod";
import { userFacingError } from "../authorization";
import { connectorsByIdentifier } from "../connectors";
import { canAuthorizeVisitors } from "../connectors/isDraft";
import { mutator } from "./mutator";
import { disconnectOAuthConnection } from "./resetOAuthConnection";

export const setConnectorAuthorizationModeSchema = z.object({
  connectedAppId: z.string(),
  authorizationMode: z.enum(["owner", "visitor"]),
});

export const setConnectorAuthorizationMode = mutator({
  schema: setConnectorAuthorizationModeSchema,
  resolve: {
    app: { kind: "connectedApp", from: "connectedAppId" },
  },
  permissions: [
    {
      permission: "connected_app:write",
      scopeId: ({ args }) => args.app.id,
    },
  ],
  fn: async ({ tx, args: { app, authorizationMode } }) => {
    if (authorizationMode === "visitor" && !canAuthorizeVisitors(app)) {
      throw userFacingError(
        "Visitor authorization needs an HTTP OAuth connector"
      );
    }
    await tx.mutate.connectedApps.update({
      id: app.id,
      authorizationMode,
      ...(authorizationMode !== app.authorizationMode
        ? {
            lastTestAt: null,
            lastTestStatus: null,
            lastTestMessage: null,
            lastTestExecutionId: null,
            lastTestUserId: null,
          }
        : {}),
      ...(authorizationMode === "visitor"
        ? {
            fresh: false,
            name: app.name || connectorsByIdentifier[app.identifier]!.name,
          }
        : {}),
    });
    if (
      authorizationMode === "visitor" &&
      app.authorizationMode !== "visitor" &&
      app.oauthConnectionId
    ) {
      await disconnectOAuthConnection(tx, app.oauthConnectionId);
    }
  },
});
